"use client";

import { useRouter } from "next/navigation";

import { Button } from "@/components/ui/button";

//

export default function Forbidden() {
  const router = useRouter();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50">
      <div className="mx-auto max-w-md text-center">
        <h1 className="mb-2 text-6xl font-extrabold text-red-500">403</h1>
        <h2 className="mb-4 text-2xl font-semibold text-gray-900">Доступ запрещен</h2>
        <p className="mb-8 text-gray-600">
          У вас нет разрешения на доступ к этому ресурсу. Пожалуйста, свяжитесь с администратором,
          если вы считаете, что это ошибка.
        </p>
        <Button icon={"ArrowLeft"} variant={"outline"} onClick={() => router.back()}>
          Назад
        </Button>
      </div>
    </div>
  );
}
